import React from "react";
//Import Icons
import clock from "../img/clock.svg";
import diaphragm from "../img/diaphragm.svg";
import money from "../img/money.svg";
import teamwork from "../img/teamwork.svg";
import home2 from "../img/wallupdate.jpg";
//Styles
import { About, Description, Image } from "../styles";
import styled from "styled-components";
import { scrollReveal, photoAnim2 } from "../animation";
import { useScroll } from "./useScroll";
import { motion } from "framer-motion";

const ServicesSection = () => {
  const [element, controls] = useScroll();
  return (
    <Services
      variants={scrollReveal}
      animate={controls}
      initial="hidden"
      ref={element}
    >
      <Description>
        <h2>
          The <span style={{ color: "#d64161" }}>Stack</span> I use{" "}
          <span style={{ color: "green" }}>M</span>
          <span style={{ color: "#2F4F4F" }}>E</span>
          <span style={{ color: "#00FFFF" }}>R</span>
          <span style={{ color: "#9ACD32" }}>N</span>
        </h2>
        <Cards>
          <Card>
            <div className="icon">
              <img alt="icon" src={clock} />
              <h3>MongoDB</h3>
            </div>
            <p>
              Database to do <span>CRUD</span> operation
            </p>
          </Card>
          <Card>
            <div className="icon">
              <img alt="icon" src={teamwork} />
              <h3>Express JS</h3>
            </div>
            <p>
              Express to provide{" "}
              <span style={{ color: "#339999" }}> server-side logic</span>
            </p>
          </Card>
          <Card>
            <div className="icon">
              <img alt="icon" src={diaphragm} />
              <h3>React Js</h3>
            </div>
            <p>
              For <span>UI/UX </span>specifically for S-P-A
            </p>
          </Card>
          <Card>
            <div className="icon">
              <img alt="icon" src={money} />
              <h3>Nodejs</h3>
            </div>
            <p>Non-blocking, event-driven servers</p>
          </Card>
        </Cards>
      </Description>
      <Image>
        <motion.img variants={photoAnim2} alt="camera" src={home2} />
      </Image>
    </Services>
  );
};

const Services = styled(About)`
  h2 {
    padding-bottom: 5rem;
  }
  p {
    width: 70%;
    padding: 2rem 0rem 4rem 0rem;
  }
`;
const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1300px) {
    justify-content: center;
  }
`;
const Card = styled.div`
  flex-basis: 20rem;
  .icon {
    display: flex;
    align-items: center;
    h3 {
      margin-left: 1rem;
      background: white;
      color: black;
      padding: 1rem;
    }
  }
`;

export default ServicesSection;
